import {Module} from "@intuitionrobotics/ts-common";
import {XhrHttpModule} from "@intuitionrobotics/thunderstorm/frontend";
import {HttpMethod} from "@intuitionrobotics/thunderstorm";
import {ClinicAnniversary_Api} from "@app-sp/app-shared/api";

type Config = {}

export const RequestKey_FetchMetroAnniversary = "FetchOverride";

class MetroModule_Class
    extends Module<Config> {

    fetchMetroAnniversaryDates(unitIds: string[]) {
        return XhrHttpModule
            .createRequest<ClinicAnniversary_Api>(HttpMethod.POST, RequestKey_FetchMetroAnniversary)
            .setRelativeUrl("/v1/clinical-anniversary-date/get-dates")
            .setJsonBody({unitIds})
            .setLabel("Fetching Metro Anniversary Dates");
    }
}

export const MetroModule = new MetroModule_Class("MetroModule");
